var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":"403","sub-title":"Nie masz dostępu do tej strony!","title":"403"}})
}
var staticRenderFns = []

export { render, staticRenderFns }